import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function DoctorListCleaner() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    console.log("real path is", location.pathname);

    if (
      path !== "/doctors" &&
      !path.includes("/doctor-booking-detail") &&
      !path.includes("/book-doctor")
    ) {
      localStorage.removeItem("doctorListState");
    }

    if (!path.includes("/blogs")) {
      localStorage.removeItem("blogsListState");
    }
  }, [location.pathname]);

  return null;
}
